import React from 'react';
import cx from 'classnames';
import {Uploader} from '../../../../components/FileUploader/uploader';
import {Column} from '../../../../stores/Form/Column';
import {AttachmentType} from '../../../../components/FileUploader';
import {useDropzone} from './useDropzone';
import {HTMLDialog} from '@priority-software/priority-style-react';
import {useContextMenu} from './useContextMenu';
import {useFormImageField} from './useFormImageField';
import styles from './styles.module.scss';

type Props = {
    placeholder?: string;
    column: Column;
    file?: AttachmentType;
    disabled?: boolean;
};

const cssCustomProps = {
    '--uploader-height': 78,
    width: '100%'
} as React.CSSProperties;

export const FormViewImageField = (props: Props) => {
    const {placeholder, column, file, disabled} = props;
    const {handlers, state, uploaderAPIRef} = useFormImageField({column, file, disabled});
    const {open, hasData, previewSrc} = state;
    const {clearFile, selectImage, setFile, openImage, onShowPreview, onHidePreview, getFileURL} =
        handlers;

    const {renderCtxMenu, onContextMenuOpen} = useContextMenu({
        clearFile,
        openImage,
        selectImage
    });

    const {dropzoneRef, handleDrop, onDragLeave, onDragStart} = useDropzone({
        setFile,
        hasData
    });

    const renderPreview = () => {
        if (!hasData) return null;

        const src = file.Data.length > 0 ? previewSrc : getFileURL();

        return (
            <div className={cx(styles.previewWrap, 'pui-fileUploader-preview')}>
                <img className={styles.previewImg} src={src} alt="Image preview" />

                {open ? (
                    <HTMLDialog
                        isOpen={open}
                        onClose={onHidePreview}
                        componentClasses={styles.previewDialog}
                        content={
                            <img className={styles.dialogImg} src={src} alt="Image full view" />
                        }
                    />
                ) : null}
            </div>
        );
    };

    return (
        <div
            className={cx(styles.component, {
                [styles.hasData]: hasData,
                [styles.disabled]: disabled
            })}
            onContextMenu={hasData ? onContextMenuOpen : undefined}
            style={cssCustomProps}
            ref={dropzoneRef}
            onDragOver={onDragStart}
            onDrop={handleDrop}
            onDragLeave={onDragLeave}
            onClick={hasData && !open ? onShowPreview : undefined}
        >
            {renderPreview()}
            {renderCtxMenu()}

            <Uploader
                ref={uploaderAPIRef}
                uploaderComponentClasses={styles.uploader}
                defaultMargin={false}
                file={null}
                readOnly={false}
                setFile={setFile}
                placeholder={placeholder}
                disabled={disabled}
            />
        </div>
    );
};
